import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { PDFDocument  } from 'pdf-lib';
import Button from "@/_component/Common/button/Button";
import { getCurrentSession } from "@/endpoints/amplify/auth";
import { API_PRIVATE_HOST, INVOICE_LINK } from '@/_constant/urlconstants';
import * as pdfjsLib from 'pdfjs-dist';
import SignCanvas from '@/_component/onboardusers/planlist/agentlist/SignCanvas'
import request from '@/apis/request'
import { Error } from "@/_service/notification/notification";
import api from '@/apis/request';
import { useNavigate } from 'react-router';

const pdfjsLibVersion = pdfjsLib.version;
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLibVersion}/build/pdf.worker.min.mjs`;

const SignAgreement = ({currentPlanId = null, userAccessId = null, toggleAgreementPopUpModal = null, txnId}) => {
  const navigate = useNavigate();
  const [pdfFile, setPdfFile] = useState(null);
  const [arrayBuffer, setArrayBuffer] = useState(null);
  const [displaySignCanvas, setDisplaySignCanvas] = useState(false);
  const [isSignatureAdded, setIsSignatureAdded] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);

  const fetchPdf = async () => {
    try {
        getCurrentSession((success, user, jwtToken) => {
            const url = `${API_PRIVATE_HOST}/referrals/sign/agreement?media-type=PREVIEW&user-plan-or-plan-id=${currentPlanId}`;
            axios({
            method: "POST",
            url: url,
            headers: {
                Authorization: jwtToken,
            },
            "responseType": 'arraybuffer'
            })
            .then(async (response) => {
                setArrayBuffer(response.data)
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                setPdfFile(url);
            })
            .catch((error) => {
              Error('Error fetching PDF');
            });
        });
    } catch (error) {
        Error('Error fetching PDF');
    }
  };

  useEffect(()=>{
    fetchPdf()
  }, [])

  const toggleSignCanvas = () => {
    setDisplaySignCanvas(!displaySignCanvas)
  }

  const extractTextPosition = async (pageIndex, searchText) => {
    const pdfDoc = await pdfjsLib.getDocument(pdfFile).promise;

    // Iterate over each page
    const page = await pdfDoc.getPage(pageIndex); 
    
    const textContent = await page.getTextContent();
  
    // Look for the text position
    let textPosition = null;
    for (const item of textContent.items) {
      if (item.str.includes(searchText)) {
        // `item.transform` contains the position (x, y)
        textPosition = { x: item.transform[4], y: item.transform[5] };
        break;
      }
    }
  
    return textPosition;
  };

  const convertToBlob = (base64Data) => {
    const byteString = atob(base64Data.split(',')[1]); // Decode base64 to binary string
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    
    // Convert binary string to an array of bytes
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the array of bytes (MIME type is 'image/png' or 'image/jpeg')
    return new Blob([arrayBuffer], { type: 'image/png' });
  };

  const addSignatureToPDF = async (signatureImageData) => {
    // Fetch the original PDF
    const pdfDoc = await PDFDocument.load(arrayBuffer);
  
    // Embed the signature image (Base64) onto the PDF
    const signatureImage = await pdfDoc.embedPng(signatureImageData); // Embed the image
    const pages = pdfDoc.getPages();
    
    pages.forEach(async (page, index) => {
        const textCordinates = await extractTextPosition(index+1, 'Authorized Signatory');

        if (textCordinates != null){
            const { width, height } = page.getSize();
            // Draw the signature image at the bottom-right of the page
            page.drawImage(signatureImage, {
                x: (width - (textCordinates.x + 100)),  // X position (adjust based on your layout)
                y: textCordinates.y + 30,  // Y position (adjust based on your layout)
                width: 100,  // Width of the signature
                height: 30,  // Height of the signature
            });
        }
        if(index == pages.length - 1){
            setTimeout(async () => {
                // Save the modified PDF
                const pdfBytes = await pdfDoc.save();
                const signedPdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
            
                // Create a downloadable URL for the signed PDF
                const signedPdfUrl = URL.createObjectURL(signedPdfBlob);
                try{
                  setPdfFile(signedPdfUrl);
                  setIsSignatureAdded(true);
                  setPdfBlob(convertToBlob(signatureImageData));
                }catch(error){

                }

            }, 500);
        }
    })
  };

  const saveSignature = (signatureDataUrl) => {
    addSignatureToPDF(signatureDataUrl);
  };

  const uploadSignedAgreement = async () => {
    let data = new FormData();
    data.append('file', pdfBlob)
    const uploadSignedAgreement = await api.post(`${API_PRIVATE_HOST}/referrals/sign/agreement?user-access-id=${userAccessId}&user-plan-or-plan-id=${currentPlanId}`, data, {headers: {"Content-Type":'multipart/form-data', Accept:'*/*'}});    
    if(uploadSignedAgreement?.data.response && uploadSignedAgreement?.data.response?.id != null){
      if(toggleAgreementPopUpModal != null){
          toggleAgreementPopUpModal();
        }
        if(txnId){
          navigate(INVOICE_LINK.replace(":txnId", txnId));
        }
        
    }else{
      Error('Unable to Upload Signed PDF')
    }
  }
  
  return (
    <div>
        {
          <SignCanvas displaySignCanvasPopUp = {displaySignCanvas} toggleSignCanvas={toggleSignCanvas} saveSignature = {saveSignature} handleSignAndUpload/>
        }
        {pdfFile && <div className='min-vw-100 min-vh-100'>
            <iframe src={pdfFile} width="100%" height="735px" />
            <div className='d-flex justify-content-center'>
              {!isSignatureAdded && <Button secondary rounded outline small
                  onClick={() => toggleSignCanvas()}
              >
                  Add Signature
              </Button>}
              {isSignatureAdded && <Button secondary rounded outline small
                  onClick={() => uploadSignedAgreement()}
              >
                  Upload
              </Button>}
            </div>
          </div>
        }
    </div>
  );
};

export default SignAgreement;
